import { toastr } from 'react-redux-toastr';

const showSuccess = (title: string, message: string) => {
    toastr.success(title, message, { removeOnHover: false });
};

export default showSuccess;
